"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = exports.default = void 0;
var _react = require("react");
/**
 * useWindowSize - React Hook for detecting window resize
 *
 * @example
 * // Usage in a functional component:
 * const myRef = useRef(null);
 *
 * const size = useWindowSize();
 *  size.height // height of the window
 *  size.width // width of the window
 *
 * return <div ref={myRef}>Swipe me!</div>;
 */
const useWindowSize = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = (0, _react.useState)({
    //! TODO: Update types on next breaking change
    width: undefined,
    height: undefined
  });
  (0, _react.useEffect)(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};
exports.useWindowSize = useWindowSize;
var _default = exports.default = useWindowSize;